module.exports = __webpack_public_path__ + "static/media/anim2.c0b01ee8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/pages/anim2.mp4
// module id = 164
// module chunks = 0